/**
 * Derives display base price and savings from API fields that may include a struck-through `priceOld`.
 *
 * @param item - Row with optional `price` / `priceOld`; `null` / `undefined` treated as missing.
 * @returns `namePrice` (strikethrough base when discounted) and non-negative `savings` delta.
 */
export function computeCartDiscountedPrice(
	item: { price?: number | null; priceOld?: number | null } | null | undefined
): { namePrice: number | null; savings: number } {
	const finalPrice = item?.price ?? null
	const hasDiscount =
		item?.priceOld != null &&
		item.priceOld > 0 &&
		finalPrice !== null &&
		item.priceOld > finalPrice
	return {
		namePrice: hasDiscount ? item!.priceOld! : finalPrice,
		savings: hasDiscount ? item!.priceOld! - finalPrice! : 0
	}
}
